/* eslint-disable class-methods-use-this */
import Model from './Model';

export default class CheckAnswer extends Model {
    // noinspection JSMethodCanBeStatic
    resource() {
        return 'check_answers';
    }
}
